/*! custom-caixa-assinatura.js — popup "Monte sua caixa" em cima dos planos da Vindi

    Elemento <ep-subscription-box> (secao sections/caixa-assinatura.liquid). Cada item
    traz um JSON com a variante e os selling plans reais (id, frequencia, preco por
    entrega, % de desconto). Daqui saem: as opcoes de plano (uniao dos planos dos
    itens), o total por entrega, a economia em 1 ano e a adicao ao carrinho.

    Contrato com o app da Vindi (assets/vindi-cart.js do app): em modo "attribute"
    cada linha leva as properties _vindi_selling_plan (id) e Plano (texto), montadas
    por window.VindiCart.planProperties quando o embed esta carregado, ou no mesmo
    formato quando nao esta; em modo "selling_plan" vai selling_plan nativo. O modo e
    lido do <script data-vindi-global data-cart-mode>. Se a Vindi mudar esse contrato,
    e aqui que se ajusta. */
(function () {
  'use strict';

  function dinheiro(cents) {
    return 'R$ ' + (cents / 100).toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }
  function escapar(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }
  function dias(freq) {
    var m = String(freq || '').match(/(\d+)/);
    return m ? Number(m[1]) : 0;
  }
  function modoVindi() {
    var s = document.querySelector('script[data-vindi-global]');
    return (s && s.dataset.cartMode) || 'selling_plan';
  }
  function propriedadesDoPlano(plano) {
    var ponte = window.VindiCart;
    if (ponte && typeof ponte.planProperties === 'function') return ponte.planProperties(plano.id, plano.name, plano.frequency);
    var p = { _vindi_selling_plan: String(plano.id) };
    p.Plano = plano.frequency ? plano.name + ' · a cada ' + plano.frequency : plano.name;
    return p;
  }

  var MAIS = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M12 5v14M5 12h14"/></svg>';
  var MENOS = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M5 12h14"/></svg>';

  class EpSubscriptionBox extends HTMLElement {}

  EpSubscriptionBox.prototype.connectedCallback = function () {
    /* fora de qualquer secao/carrossel: o popup e fixo e nao pode herdar overflow/transform */
    if (this.parentElement !== document.body) { document.body.appendChild(this); return; }
    if (this.__pronto) return;
    this.__pronto = true;

    this.itens = [];
    var self = this;
    this.querySelectorAll('.subscription-popup-item').forEach(function (el) {
      var dados = {};
      try { dados = JSON.parse(el.querySelector('.caixa-item-dados').textContent); } catch (e) { return; }
      dados.el = el;
      dados.planos = (dados.planos || []).filter(function (p) { return p && p.id; });
      self.itens.push(dados);
    });

    /* uniao dos planos (por id), em ordem de dias */
    var mapa = {};
    this.itens.forEach(function (it) { it.planos.forEach(function (p) { if (!mapa[p.id]) mapa[p.id] = { id: p.id, name: p.name, frequency: p.frequency, dias: dias(p.frequency), pct: Number(p.pct) || 0, pctType: p.pctType }; }); });
    /* so planos com periodicidade em dias ("30 dias"); um plano de teste "a cada dia" fica de fora */
    this.planos = Object.keys(mapa).map(function (k) { return mapa[k]; }).filter(function (p) { return p.dias > 0; }).sort(function (a, b) { return a.dias - b.dias; });

    this.quantidades = {};
    this.planoId = null;
    this.ocupado = false;

    this.elPlanos = this.querySelector('[data-planos]');
    this.elResumo = this.querySelector('[data-resumo]');
    this.elVazio = this.querySelector('[data-vazio]');
    this.elValor = this.querySelector('[data-valor]');
    this.elPlanoNome = this.querySelector('[data-plano-nome]');
    this.elEconomia = this.querySelector('[data-economia]');
    this.elMensagem = this.querySelector('[data-mensagem]');
    this.elAssinar = this.querySelector('[data-assinar]');

    this.montarPlanos();
    this.escolherPlano(this.planoPadrao(Number(this.dataset.planHighlight)));
    this.ligarEventos();
    this.render();
  };

  EpSubscriptionBox.prototype.planoPadrao = function (diasPreferidos) {
    var achado = null;
    if (diasPreferidos) this.planos.forEach(function (p) { if (!achado && p.dias === diasPreferidos) achado = p; });
    return achado || this.planos[0] || null;
  };

  EpSubscriptionBox.prototype.montarPlanos = function () {
    if (!this.elPlanos) return;
    var destaque = Number(this.dataset.planHighlight) || 0;
    var flag = this.dataset.planHighlightFlag || '';
    var nome = 'caixa-plano-' + (this.id || 'x');
    this.elPlanos.innerHTML = this.planos.map(function (p) {
      var tag = p.pct > 0 ? '<div class="subscription-content__title__tag">' + (p.pctType === 'percentage' || !p.pctType ? escapar(p.pct) + '% OFF' : dinheiro(p.pct * 100) + ' OFF') + '</div>' : '';
      var etiqueta = destaque && p.dias === destaque && flag ? '<span class="subscription-popup__recurrence-flag">' + escapar(flag) + '</span>' : '';
      return '<div class="subscription-popup__recurrence-option-wrapper">' + etiqueta +
        '<label class="subscription-popup__recurrence-option" data-plano-id="' + escapar(p.id) + '">' +
        '<input type="radio" name="' + escapar(nome) + '" class="subscription-popup__recurrence-input" value="' + escapar(p.id) + '">' +
        '<span class="subscription-popup__recurrence-radio" aria-hidden="true"></span>' +
        '<span class="subscription-popup__recurrence-label">' + escapar((p.frequency || p.name).toUpperCase()) + '</span>' + tag +
        '</label></div>';
    }).join('');
  };

  EpSubscriptionBox.prototype.escolherPlano = function (plano) {
    this.planoId = plano ? plano.id : null;
    var id = this.planoId;
    this.querySelectorAll('.subscription-popup__recurrence-option').forEach(function (lab) {
      var ativo = String(lab.dataset.planoId) === String(id);
      lab.classList.toggle('subscription-popup__recurrence-option--active', ativo);
      var input = lab.querySelector('input'); if (input) input.checked = ativo;
    });
  };

  EpSubscriptionBox.prototype.planoAtual = function () {
    var id = this.planoId; var achado = null;
    this.planos.forEach(function (p) { if (String(p.id) === String(id)) achado = p; });
    return achado;
  };

  /* quantidade de cada item: o <quantity-input> do tema dentro do card e a fonte da verdade */
  EpSubscriptionBox.prototype.lerQuantidades = function () {
    var q = {};
    this.itens.forEach(function (it) {
      var input = it.el.querySelector('.quantity-input__input');
      var n = input ? parseInt(input.value, 10) : 0;
      q[it.variantId] = Number.isFinite(n) && n > 0 ? n : 0;
      it.el.classList.toggle('subscription-popup-item--has-quantity', q[it.variantId] > 0);
    });
    this.quantidades = q;
  };

  EpSubscriptionBox.prototype.mudarQuantidade = function (variantId, delta) {
    var item = null;
    this.itens.forEach(function (it) { if (String(it.variantId) === String(variantId)) item = it; });
    if (!item) return;
    var botao = item.el.querySelector(delta > 0 ? '.quantity-input__button--increase' : '.quantity-input__button--decrease');
    if (botao) { botao.click(); return; }
    var input = item.el.querySelector('.quantity-input__input');
    if (input) { input.value = Math.max(0, (parseInt(input.value, 10) || 0) + delta); input.dispatchEvent(new Event('change', { bubbles: true })); }
  };

  EpSubscriptionBox.prototype.ligarEventos = function () {
    var self = this;
    this.querySelectorAll('[data-popup-close]').forEach(function (b) { b.addEventListener('click', function () { self.fechar(); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !self.hidden) self.fechar(); });

    /* qualquer mexida nas quantidades dos cards ou do resumo -> reler e redesenhar */
    var agendar = function () { clearTimeout(self.__t); self.__t = setTimeout(function () { self.lerQuantidades(); self.render(); }, 30); };
    ['quantity-change', 'change', 'input', 'click'].forEach(function (ev) { self.addEventListener(ev, agendar); });

    if (this.elPlanos) this.elPlanos.addEventListener('click', function (e) {
      var lab = e.target.closest('.subscription-popup__recurrence-option');
      if (!lab) return;
      var id = lab.dataset.planoId; var plano = null;
      self.planos.forEach(function (p) { if (String(p.id) === String(id)) plano = p; });
      self.escolherPlano(plano); self.render();
    });

    if (this.elResumo) this.elResumo.addEventListener('click', function (e) {
      var b = e.target.closest('[data-delta]');
      if (!b) return;
      e.preventDefault();
      self.mudarQuantidade(b.dataset.variant, Number(b.dataset.delta));
    });

    if (this.elAssinar) this.elAssinar.addEventListener('click', function () { self.assinar(); });

    /* gatilhos: botoes dos cards de plano (bloco antigo) e qualquer [data-caixa-assinatura] */
    if (this.dataset.openFromTriggers === 'true') {
      document.addEventListener('click', function (e) {
        var alvo = e.target.closest('.subscription-popup-trigger, [data-caixa-assinatura]');
        if (!alvo) return;
        e.preventDefault(); e.stopPropagation();
        var pedido = dias(alvo.dataset.defaultRecurrence || alvo.dataset.caixaAssinatura || '');
        self.abrir(pedido);
      }, true);
    }
  };

  EpSubscriptionBox.prototype.abrir = function (diasPreferidos) {
    if (diasPreferidos) { var p = this.planoPadrao(diasPreferidos); if (p) this.escolherPlano(p); }
    this.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
    this.avisar('');
    this.render();
    var fechar = this.querySelector('.subscription-popup__close'); if (fechar) fechar.focus();
  };
  EpSubscriptionBox.prototype.fechar = function () {
    this.setAttribute('hidden', '');
    document.body.style.overflow = '';
  };
  EpSubscriptionBox.prototype.avisar = function (texto) {
    if (!this.elMensagem) return;
    this.elMensagem.textContent = texto || '';
    this.elMensagem.hidden = !texto;
    if (!texto) delete this.elMensagem.dataset.erro;
  };

  EpSubscriptionBox.prototype.temPlano = function (item, plano) {
    return !!plano && item.planos.some(function (p) { return String(p.id) === String(plano.id); });
  };
  EpSubscriptionBox.prototype.precoNoPlano = function (item, plano) {
    var achado = null;
    if (plano) item.planos.forEach(function (p) { if (String(p.id) === String(plano.id)) achado = p; });
    return achado ? Number(achado.perDeliveryPrice) : Number(item.price);
  };

  EpSubscriptionBox.prototype.render = function () {
    var self = this;
    var plano = this.planoAtual();
    /* produto sem o plano escolhido fica marcado no card e fora da caixa (nunca vai como compra avulsa) */
    this.itens.forEach(function (it) { it.el.classList.toggle('subscription-popup-item--sem-plano', !!plano && !self.temPlano(it, plano)); });
    var todos = this.itens.filter(function (it) { return (self.quantidades[it.variantId] || 0) > 0; });
    var escolhidos = todos.filter(function (it) { return self.temPlano(it, plano); });
    var foraDoPlano = todos.length - escolhidos.length;

    if (this.elResumo) {
      this.elResumo.innerHTML = escolhidos.map(function (it) {
        var q = self.quantidades[it.variantId];
        return '<li class="subscription-popup__summary-item">' +
          '<span class="subscription-popup__summary-item-title">' + escapar(it.title) + '</span>' +
          '<div class="subscription-popup__summary-quantity quantity-input">' +
          '<button type="button" class="quantity-input__button" data-delta="-1" data-variant="' + escapar(it.variantId) + '" aria-label="Diminuir">' + MENOS + '</button>' +
          '<input type="number" class="quantity-input__input" value="' + q + '" readonly aria-label="Quantidade">' +
          '<button type="button" class="quantity-input__button" data-delta="1" data-variant="' + escapar(it.variantId) + '" aria-label="Aumentar">' + MAIS + '</button>' +
          '</div></li>';
      }).join('');
    }
    this.classList.toggle('subscription-popup--empty', escolhidos.length === 0);
    if (this.elVazio) this.elVazio.style.display = escolhidos.length ? 'none' : 'block';

    var total = 0, economiaAno = 0;
    escolhidos.forEach(function (it) {
      var q = self.quantidades[it.variantId];
      var noPlano = self.precoNoPlano(it, plano);
      total += q * noPlano;
      if (plano && plano.dias > 0) economiaAno += q * Math.max(0, Number(it.price) - noPlano) * Math.round(365 / plano.dias);
    });
    if (this.elValor) this.elValor.textContent = dinheiro(total);
    if (this.elPlanoNome) this.elPlanoNome.textContent = plano ? (plano.frequency || plano.name) : '';
    if (this.elEconomia) {
      var modelo = escapar(this.dataset.textSavings || 'Em 1 ano você terá economizado cerca de [valor].');
      this.elEconomia.innerHTML = modelo.replace('[valor]', '<strong class="subscription-popup__savings-amount">' + dinheiro(economiaAno) + '</strong>');
    }
    if (this.elAssinar) this.elAssinar.disabled = this.ocupado || !plano || escolhidos.length === 0;
    if (foraDoPlano > 0 && plano) this.avisar(foraDoPlano + (foraDoPlano === 1 ? ' produto escolhido não tem o plano de ' : ' produtos escolhidos não têm o plano de ') + (plano.frequency || plano.name) + ' e ficou de fora da caixa.');
    else if (this.elMensagem && !this.ocupado && this.elMensagem.dataset.erro !== '1') this.avisar('');
  };

  EpSubscriptionBox.prototype.assinar = function () {
    var self = this;
    var plano = this.planoAtual();
    var escolhidos = this.itens.filter(function (it) { return (self.quantidades[it.variantId] || 0) > 0 && self.temPlano(it, plano); });
    if (!plano || !escolhidos.length || this.ocupado) return;

    var modo = modoVindi();
    var itens = escolhidos.map(function (it) {
      var linha = { id: Number(it.variantId), quantity: self.quantidades[it.variantId] };
      if (modo === 'attribute') linha.properties = propriedadesDoPlano(plano);
      else linha.selling_plan = Number(plano.id);
      return linha;
    });

    this.ocupado = true;
    this.elAssinar.disabled = true;
    this.elAssinar.classList.add('is-loading');
    this.avisar('');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: itens }) })
      .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, json: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          self.avisar((res.json && (res.json.description || res.json.message)) || self.dataset.textError || 'Não foi possível adicionar.');
          if (self.elMensagem) self.elMensagem.dataset.erro = '1';
          return;
        }
        /* o tema rele o carrinho com este evento e abre a gaveta com o outro */
        document.dispatchEvent(new CustomEvent('fg-cart:auto-updated', { detail: { origem: 'caixa-assinatura' } }));
        self.fechar();
        window.dispatchEvent(new CustomEvent('drawer:open', { detail: { name: 'cart' } }));
        /* zera as quantidades para a proxima vez */
        self.itens.forEach(function (it) { var input = it.el.querySelector('.quantity-input__input'); if (input && parseInt(input.value, 10) > 0) { var b = it.el.querySelector('.quantity-input__button--decrease'); var n = parseInt(input.value, 10); while (n-- > 0 && b) b.click(); } });
      })
      .catch(function () { self.avisar(self.dataset.textError || 'Não foi possível adicionar.'); })
      .then(function () { self.ocupado = false; self.elAssinar.classList.remove('is-loading'); self.lerQuantidades(); self.render(); });
  };

  if (!window.customElements.get('ep-subscription-box')) window.customElements.define('ep-subscription-box', EpSubscriptionBox);
})();
